/* Keep native app behavior; relocate only mobile entry points in this theme. */
(() => {
  'use strict';
  if (window.mmsMobileToolsInitialized) return;
  window.mmsMobileToolsInitialized = true;

  const mobile = window.matchMedia('(max-width: 749px)');
  const originalTabIndex = new WeakMap();
  let closeObserver;

  function chatActivator() {
    const host = document.querySelector('shopify-chat');
    const runtime = host?.shadowRoot?.querySelector('shopify-agent-runtime');
    const button = runtime?.shadowRoot?.querySelector('button[part="activator"]');
    if (!button || !button.isConnected || button.disabled || typeof host.show !== 'function') return null;
    return { host, button };
  }

  let currencyWidget;
  let currencyAnchor;
  function readyCurrency() {
    const widget = document.querySelector('.vitals-currency-converter');
    const slot = document.querySelector('.mms-footer-currency');
    if (!widget || !slot || !widget.querySelector('[role="combobox"][aria-label="Select currency"]')) return false;
    if (widget !== currencyWidget) {
      currencyAnchor?.remove();
      currencyAnchor = document.createComment('mms currency original location');
      widget.before(currencyAnchor);
      currencyWidget = widget;
    }
    if (mobile.matches) {
      if (widget.parentNode !== slot) slot.append(widget);
      widget.setAttribute('data-mms-footer-currency', '');
    } else {
      widget.removeAttribute('data-mms-footer-currency');
      if (currencyAnchor?.isConnected && widget.parentNode !== currencyAnchor.parentNode) currencyAnchor.after(widget);
    }
    return true;
  }

  function readyChat() {
    const chat = chatActivator();
    const link = document.querySelector('[data-mms-footer-chat]');
    if (!chat || !link) return false;
    chat.host.setAttribute('data-mms-footer-chat-ready', '');
    if (!originalTabIndex.has(chat.button)) originalTabIndex.set(chat.button, chat.button.getAttribute('tabindex'));
    if (mobile.matches) chat.button.setAttribute('tabindex', '-1');
    else {
      const prior = originalTabIndex.get(chat.button);
      if (prior === null) chat.button.removeAttribute('tabindex');
      else chat.button.setAttribute('tabindex', prior);
    }
    return true;
  }

  document.addEventListener('click', (event) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('[data-mms-footer-chat]');
    if (!link) return;
    const chat = chatActivator();
    if (!chat) return; // Keep the contact link when the app is unavailable.
    event.preventDefault();
    // Stop the originating footer click before native document click-outside
    // handlers run; use the native idempotent public API rather than a toggle.
    event.stopPropagation();
    closeObserver?.disconnect();
    closeObserver = new MutationObserver((records) => {
      if (chat.button.getAttribute('aria-expanded') !== 'false') return;
      if (!records.some((record) => record.oldValue === 'true')) return;
      closeObserver.disconnect();
      window.setTimeout(() => { if (link.isConnected) link.focus({ preventScroll: true }); }, 0);
    });
    closeObserver.observe(chat.button, { attributes: true, attributeFilter: ['aria-expanded'], attributeOldValue: true });
    chat.host.show();
  }, true);

  // Inbox hydrates after load, including its nested shadow roots. Never hide its
  // launcher until a working native button and the replacement link both exist.
  let attempts = 0;
  const timer = window.setInterval(() => {
    if (readyChat() || ++attempts >= 180) window.clearInterval(timer);
  }, 500);
  readyChat();
  document.addEventListener('shopify:section:load', readyChat);
  mobile.addEventListener('change', readyChat);
  let currencyAttempts = 0;
  const currencyTimer = window.setInterval(() => {
    if (readyCurrency() || ++currencyAttempts >= 180) window.clearInterval(currencyTimer);
  }, 500);
  readyCurrency();
  document.addEventListener('shopify:section:load', readyCurrency);
  mobile.addEventListener('change', readyCurrency);
})();
